export type SocialLinkOutcome =
  | { status: 'linked' }
  | { status: 'cancelled' }
  | { status: 'redirecting' }
  | { status: 'error'; code: string };

/**
 * Web has no in-app browser session to await: hand the tab to the provider and
 * let the callback bring it back to Settings. A popup would be blocked as often
 * as not, so this is a full-page navigation and the outcome is read from the
 * `?error=` parameter on return, not from a resolved promise.
 */
export async function openSocialLinkFlow(input: {
  authorizeUrl: string;
  returnUrl: string;
}): Promise<SocialLinkOutcome> {
  void input.returnUrl;
  window.location.assign(input.authorizeUrl);
  return { status: 'redirecting' };
}
